import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

const accountPreferenceAPIURL = "api/v1/AccountPreference";

export interface AccountPreferenceApiParameter extends ApiParameter {
    id?: string;
    UserProfileId: string;
    PreferenceKey?: string;
    Value?: string;
    CustomerId?: string;
}

export class AccountPreferenceService {
    static async getAccountPreferences(parameter: AccountPreferenceApiParameter) {
        if(parameter.UserProfileId != null && parameter.UserProfileId != "" && parameter.UserProfileId != undefined){
            return await get<any>(`${accountPreferenceAPIURL}?UserProfileId=${parameter.UserProfileId}`);
        }
    }
    static async createAccountPreferences(parameter: AccountPreferenceApiParameter) {
        if(parameter.UserProfileId != null && parameter.UserProfileId != "" && parameter.UserProfileId != undefined){
        return await post<any>(`${accountPreferenceAPIURL}`, parameter);
        }
    }
}